/*
 * @Author: 杜娇艳 12104317+du-jiaoyan@user.noreply.gitee.com
 * @Date: 2025-06-15 14:24:00
 * @LastEditors: jiaoyan.du jiaoyan.du@huifu.com
 * @LastEditTime: 2025-07-11 16:29:50
 * @FilePath: /game-console/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Router from "vue-router";
import store from "../store";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/Login.vue"),
      meta: { requiresAuth: false },
    },
    {
      path: "/",
      component: () => import("@/views/layout/Layout.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "首页",
          component: () => import("@/views/Dashboard.vue"),
        },
        {
          path: "/characters",
          name: "角色管理",
          component: () => import("@/views/Characters.vue"),
          meta: { title: "角色管理" },
        },
        {
          path: "/weapons",
          name: "武器管理",
          component: () => import("@/views/Weapons.vue"),
          meta: { title: "武器管理" },
        },
        {
          path: "/skins",
          name: "皮肤管理",
          component: () => import("@/views/Skins.vue"),
          meta: { title: "皮肤管理" },
        },
        {
          path: "/players",
          name: "玩家管理",
          component: () => import("@/views/Players.vue"),
          meta: { title: "玩家管理" },
        },
        {
          path: "/stores",
          name: "门店管理",
          component: () => import("@/views/Stores.vue"),
          meta: { title: "门店管理" },
        },
        {
          path: "/appoint",
          name: "预约管理",
          component: () => import("@/views/Appoint.vue"),
          meta: { title: "预约管理" },
        },
      ],
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
